import {
  useEffect,
  useState
} from "react";

import useMedia
  from "../hooks/useMedia";

import MediaHeader
  from "../components/headers/MediaHeader";


import UploadMediaDialog
  from "../components/dialogs/UploadMediaDialog";
import MediaPickerDialog from "../components/pickers/MediaPickerDialog";

import useDebounce from "../hooks/useDebounce";
import useSelection from "../hooks/useSelection";
import MediaListMenu from "../components/lists/MediaListMenu";
import MediaSidebar from "../components/sidebar/MediaSidebar";
import BulkToolbar from "../components/bulk/BulkToolbar";
import MediaToolbar from "../components/headers/MediaToolbar";
import MediaListForm from "../components/forms/MediaListForm";
import useMediaLists from "../hooks/useMediaLists";
import useToast from "../components/common/toast/useToast";
import ConfirmDialog from "../components/common/confirm/ConfirmDialog";
import MediaListSelectorDialog from "../components/dialogs/MediaListSelectorDialog";
import MediaDetailsDrawer from "../components/drawer/MediaDetailsDrawer";
import MediaTable from "../components/tables/MediaTable";
import Pagination from "../components/common/Pagination";
import MediaLayout from "../../UI/layouts/BuilderLayout";

export default function MediaLibraryPage() {

  const {

    loadStorage,

    loadMedia,bulkDelete

  } = useMedia();
   const toast =
        useToast();
    
const {

    createList,

    loadLists,duplicateList,deleteList,unpinList,unfavoriteList,favoriteList,pinList,updateList,loadListMedia,
    bulkAddMedia,moveMedia,copyMedia,bulkRemoveMedia,removeMedia

} = useMediaLists();
  const [

    storage,

    setStorage

  ] = useState(null);
const [

  media,

  setMedia

] = useState(
  null
);
  const [

    mediaRows,

    setMediaRows

  ] = useState([]);

  const [

    total,

    setTotal

  ] = useState(0);
 const [

    mediaLists,

    setMediaLists

] = useState([]);
  const [

    loading,

    setLoading

  ] = useState(false);
  const [

    loadingLists,

    setLoadingLists

  ] = useState(false);
  const [

    confirmOpen,

    setConfirmOpen

] = useState(false);

const [

    confirmConfig,

    setConfirmConfig

] = useState({

    title: "",

    message: "",

    confirmText: "Delete",

    onConfirm: null

});


const {

    selected,

    selectedCount,

    toggle,

    toggleAll,

    isSelected,

    clear,

    allSelected

}

=

useSelection(
    mediaRows
);
function openBulkRemove(){

    setConfirmConfig({

        title: "Remove  Files",

        message: `Delete ${selected.length} selected file(s)?`,

        confirmText: "Delete",

        onConfirm: async () => {

            try{

                setLoading(true);

                await bulkRemoveMedia(filters?.listId,{

                    mediaIds:selected

                });

                toast.success(

                    `${selected.length} file(s) deleted successfully.`

                );

                clear();

                await refresh(filters);

                await refreshLists();

            }

            finally{

                setLoading(false);

            }

        }

    });

    setConfirmOpen(true);

}

async function handleBulkDelete() {

    try {

        setLoading(true);

        await bulkDelete({

            mediaIds: selected

        });

        toast.success(

            `${selected.length} file(s) deleted successfully.`

        );

        clear();

        await refresh(filters);

        await refreshLists();

    } catch (error) {

        toast.error(

            error?.response?.data?.message ||

            "Delete failed."

        );

    } finally {

        setLoading(false);

    }

}

function openBulkDelete() {

    setConfirmConfig({

        title: "Delete Files",

        message:

            `Delete ${selected.length} selected file(s)?`,

        confirmText: "Delete",

        onConfirm: handleBulkDelete

    });

    setConfirmOpen(true);

}
  const [

    moveOpen,

    setMoveOpen

  ] = useState(false);
  const [

    createListOpen,

    setCreateListOpen

  ] = useState(false);
  const [

    copyOpen,

    setCopyOpen

  ] = useState(false);
  const [

    removeOpen,

    setRemoveOpen

  ] = useState(false);
  const [

    addOpen,

    setAddOpen

  ] = useState(false);
const [

    editingList,

    setEditingList

]=useState(null);

const [

    renameOpen,

    setRenameOpen

]=useState(false);
const [

    detailsOpen,

    setDetailsOpen

] = useState(false);

const [

    activeMediaId,

    setActiveMediaId

] = useState(null);
  const [

    uploadOpen,

    setUploadOpen

  ] = useState(false);
  const [

    pickerOpen,

    setPickerOpen

  ] = useState(false);
const [filters, setFilters] = useState({

    search: "",

    folder: "",

    mimeGroup: "",

    sort: "id",

    order: "DESC",

    page: 1,

    limit: 10

});
const debouncedSearch =
  useDebounce(
    filters.search,
    300
  );
  const [

    pagination,

    setPagination

] = useState(null);

const [

    menu,

    setMenu

] = useState({

    open:false,

    list:null,

    anchor:null

});
async function refreshLists(){
 
    const result = await loadLists({

        limit:500,

        sort:"name",

        order:"ASC"

    });

    setMediaLists(
        result.rows
    );

}
async function handleCreateList(values) {

    try {

        setLoadingLists(true);

        await createList(values);

        setCreateListOpen(false);
toast.success(
    "Media list created successfully."
);
        await refreshLists();

    } catch (error) {

        console.error(error);

    } finally {

        setLoadingLists(false);

    }

}

async function handleDuplicate(list) {

    try {

        setLoadingLists(true);

        await duplicateList(list.id);

        await refreshLists();

    } catch (error) {

        console.error(error);

    } finally {

        setLoadingLists(false);

    }

}
async function handleMove({

    listId,

    mediaIds

}){

    try{

        setLoadingLists(true);

        await moveMedia(

            filters?.listId,

            {

                destinationListId: listId,

                mediaIds

            }

        );

        toast.success(

            `${mediaIds.length} file(s) moved successfully.`

        );

        setMoveOpen(false);

        clear();

        await refresh(filters);

        await refreshLists();

    }

    catch(error){

        toast.error(

            error?.response?.data?.message ||

            "Move failed."

        );

    }

    finally{

        setLoadingLists(false);

    }

}async function handleCopy({

    listId,

    mediaIds

}){

    try{

        setLoadingLists(true);

        await copyMedia(

            filters?.listId,

            {

                destinationListId: listId,

                mediaIds

            }

        );

        toast.success(

            `${mediaIds.length} file(s) copied successfully.`

        );

        setCopyOpen(false);

        clear();

        await refresh(filters);

        await refreshLists();

    }

    catch(error){

        toast.error(

            error?.response?.data?.message ||

            "Copy failed."

        );

    }

    finally{

        setLoadingLists(false);

    }

}
function openRemoveFromList(listId, mediaId, listName) {

    setConfirmConfig({

        title: "Remove From List",

        message: `Remove this file from "${listName}"?`,

        confirmText: "Remove",

        onConfirm: async () => {

            try {

                setLoadingLists(true);

                await removeMedia(

                    listId,

                    mediaId

                );

                toast.success(

                    "File removed from list."

                );

                await refresh(filters);

                await refreshLists();

            }

            catch (error) {

                toast.error(

                    error?.response?.data?.message ||

                    "Remove failed."

                );

            }

            finally {

                setLoadingLists(false);

            }

        }

    });

    setConfirmOpen(true);

}

const [

    deleteOpen,

    setDeleteOpen

] = useState(false);

const [

    deletingList,

    setDeletingList

] = useState(null);
async function handleDelete() {

    if (!deletingList) {

        return;

    }

    try {

        setLoadingLists(true);

        await deleteList(
            deletingList.id
        );

        if (
            filters?.listId === deletingList.id
        ) {

            setFilters(previous => ({

                ...previous,

                listId: null,

                page: 1

            }));

        }

        toast.success(
            "Media list deleted successfully."
        );

        setDeleteOpen(false);

        setDeletingList(null);

        await refreshLists();

    } catch (error) {

        console.error(error);

        toast.error(

            error?.response?.data?.message ||

            "Failed to delete media list."

        );

    } finally {

        setLoadingLists(false);

    }

}

async function handlePin(list) {

    try {

        setLoadingLists(true);

        if (list.pinned) {

            await unpinList(list.id);

        } else {

            await pinList(list.id);

        }

        await refreshLists();

    } catch (error) {

        console.error(error);

    } finally {

        setLoadingLists(false);

    }

}

async function handleFavorite(list) {

    try {

        setLoadingLists(true);

        if (list.favorite) {

            await unfavoriteList(list.id);

        } else {

            await favoriteList(list.id);

        }

        await refreshLists();

    } catch (error) {

        console.error(error);

    } finally {

        setLoadingLists(false);

    }

}
async function handleRename(values) {

    try {

        setLoadingLists(true);

        await updateList(

            editingList.id,

            values

        );
toast.success(
    "Media list updated successfully."
);
        setRenameOpen(false);

        setEditingList(null);

        await refreshLists();

    } catch (error) {

        console.error(error);

    } finally {

        setLoadingLists(false);

    }

}

async function handleBulkAdd({

    listId,

    mediaIds

}){

    try{

        setLoadingLists(true);

        await bulkAddMedia(

            listId,

            {

                mediaIds

            }

        );

        toast.success(

            `${mediaIds.length} file(s) added successfully.`

        );

        setAddOpen(false);

        clear();

        await refreshLists();

        await refresh(filters);

    }

    catch(error){

        console.error(error);

        toast.error(

            error?.response?.data?.message ||

            "Failed to add files."

        );

    }

    finally{

        setLoadingLists(false);

    }

}
  /* =========================
     LOAD DATA
  ========================= */

 async function refresh(filters) {

    try {

        const storageData =
            await loadStorage();

        let mediaData;

        if (filters?.listId) {

            mediaData =
                await loadListMedia(

                    filters?.listId,

                    filters

                );

        } else {

            mediaData =
                await loadMedia(filters);

        }

        setStorage(storageData);

        setMediaRows(mediaData.rows);

        setTotal(mediaData.total);

        setPagination(mediaData.pagination);

    } finally {

        setLoading(false);

    }

}

  /* =========================
     INIT
  ========================= */

 useEffect(() => {

    refreshLists();

}, []);

useEffect(() => {

    setLoading(true);

    refresh(filters);

}, [

    debouncedSearch,

    filters.folder,

    filters.mimeGroup,

    filters.sort,

    filters.order,

    filters.page,

    filters.limit,

    filters?.listId

]);

  return (

    <div
      style={{margin:"10px",marginTop:"64px"}}
    >
<MediaLayout

    title="Media Library"

    onAction={() =>

        setUploadOpen(true)

    }

    sidebar={

        <div className="media-sidebar-panel">

            <button

                className="btn btn-primary"

                onClick={()=>

                    setUploadOpen(true)

                }

            >

                + Upload File

            </button>

            <MediaSidebar

                lists={mediaLists}

                loading={loadingLists}

                selectedList={filters?.listId ?? null}

                onSelect={listId =>

                    setFilters(previous => ({

                        ...previous,

                        listId,

                        page:1

                    }))

                }

                onCreate={()=>

                    setCreateListOpen(true)

                }

                onMenu={({list,anchor})=>

                    setMenu({

                        open:true,

                        list,

                        anchor

                    })

                }

            />

        </div>

    }

    toolbar={

        selectedCount

        ?

        <BulkToolbar

            selectedCount={selectedCount}

            currentListId={filters?.listId}

            onMove={()=>

                setMoveOpen(true)

            }

            onCopy={()=>

                setCopyOpen(true)

            }

            onAdd={()=>

                setAddOpen(true)

            }

            onRemove={openBulkRemove}

            onDelete={openBulkDelete}

            onDownload={() => {}}

            onClear={clear}

        />

        :

        <MediaToolbar

            filters={filters}

            onChange={setFilters}

        />

    }

    footer={

        <Pagination

            pagination={pagination}

            onPageChange={page=>

                setFilters(previous=>({

                    ...previous,

                    page

                }))

            }

        />

    }

>

    <MediaTable

        loading={loading}

        rows={mediaRows}

        onRefresh={refresh}

        selected={selected}

        isSelected={isSelected}

        toggle={toggle}

        toggleAll={toggleAll}

        allSelected={allSelected}

        setDetailsOpen={()=>

            setDetailsOpen(true)

        }

        setActiveMediaId={setActiveMediaId}

        onUpload={()=>

            setUploadOpen(true)

        }

    />

</MediaLayout>

          
      
         
               

 
      <UploadMediaDialog

        open={
          uploadOpen 
        }

        onClose={() =>
          setUploadOpen(
            false
          )
        }

        onSuccess={() => {

          setUploadOpen(
            false
          );

          refresh();

        }}

      />

{createListOpen?<MediaListForm  initialValues={{}}

    loading ={loading}

    submitLabel = "Create"

    onSubmit={handleCreateList}

    onCancel={()=>setCreateListOpen(false)} />:""}

    {
    renameOpen &&

    <MediaListForm

        initialValues={editingList}

        loading={loadingLists}

        submitLabel="Save"

        onSubmit={handleRename}

        onCancel={() => {

            setRenameOpen(false);

            setEditingList(null);

        }}

    />
}
      
{/* <button  onClick={()=>{setPickerOpen(true)}}>Open Picker </button> */}
{
  media && (

    <div className="
      p-3
      border
      rounded
    ">

      <div>
        Selected:
      </div>

      <div>
        {media.original_name}
      </div>

      <div>
        {media.mime_type}
      </div>

    </div>

  )
}

<MediaPickerDialog
   folder="documents"
  open={
    pickerOpen
  }

  onClose={
    () =>
      setPickerOpen(
        false
      )
  }

  onSelect={
    media => {

      setMedia(
        media
      );

      setPickerOpen(
        false
      );

    }
  }

/>

{deleteOpen?<ConfirmDialog

    open={deleteOpen}

    title="Delete Media List"

    message={`Delete "${deletingList?.name}" ?`}

    confirmText="Delete"

    onCancel={() => {

        setDeleteOpen(false);

        setDeletingList(null);

    }}

    onConfirm={handleDelete}

/>:""}

<MediaListMenu

    open={menu.open}

    list={menu.list}

    anchor={menu.anchor}
     onRename={list => {

        setEditingList(list);

        setRenameOpen(true);

    }}

    onDuplicate={handleDuplicate}

    onPin={handlePin}

    onFavorite={handleFavorite}

    onDelete={(list)=>{
        setDeleteOpen(true);

        setDeletingList(list);}}
    onClose={()=>

        setMenu({

            open:false

        })

    }


/>
<MediaListSelectorDialog

    open={addOpen}

    mode="add"

    lists={mediaLists}

    selected={selected}

    loading={loadingLists}

    onClose={()=>

        setAddOpen(false)

    }

    onSubmit={handleBulkAdd}

/>


<MediaListSelectorDialog

    open={copyOpen}

    mode="copy"

    lists={mediaLists}

    selected={selected}

    loading={loadingLists}

    onClose={()=>

        setCopyOpen(false)

    }

    onSubmit={handleCopy}

/>
<MediaListSelectorDialog

    open={moveOpen}

    mode="move"

    lists={mediaLists}

    selected={selected}

    loading={loadingLists}

    onClose={()=>

        setMoveOpen(false)

    }

    onSubmit={handleMove}

/>
{confirmOpen?<ConfirmDialog

    open={confirmOpen}

    title={confirmConfig.title}

    message={confirmConfig.message}

    confirmText={confirmConfig.confirmText}

    onCancel={() => {

        setConfirmOpen(false);

    }}

    onConfirm={async () => {

        await confirmConfig.onConfirm?.();

        setConfirmOpen(false);

    }}

/>:""}
<MediaDetailsDrawer

    open={detailsOpen}

    mediaId={activeMediaId}

    onClose={() => {

        setDetailsOpen(false);

        setActiveMediaId(null);

    }}
   
    refreshLists={refreshLists}
    setAddOpen={setAddOpen}
    addOpen={addOpen}
    loadingList={loadingLists}
    setEditingMedia={setRenameOpen}
    setRenameOpen={setRenameOpen}
    setSelected={toggle}
    
    selected={selected}

    isSelected={isSelected}

    toggle={toggle}
    setMoveOpen={setMoveOpen}
    openBulkDelete={openBulkDelete}
     onRemove={openRemoveFromList}

/>

        

          


</div>
  );

}